// This is just an example,
// so you can safely delete all default props below

export default {
    profile: 'My Profile',
    given_name: 'First Name',
    family_name: 'Last Name',
    address_line_1: 'Address',
    postal_code: 'Postal Code',
    locality: 'City',
    country_code: 'Country',
    phone_number: 'Mobile Phone',
    email: 'Email',
    email_repeat: 'Repeat Email',
    error_given_name: 'First name must be supplied',
    error_family_name: 'Last name must be supplied',
    error_address_line_1: 'Address must be supplied',
    error_postal_code: 'Postal code must be supplied',
    error_locality: 'City must be supplied',
    error_country_code: 'Country must be supplied',
    error_phone_number: 'Mobile phone number is not valid',
    error_email: 'Email is not valid',
    error_email_repeat: 'Email repeated must be the same with email',
    error_email_exist: 'Email is already in use',
    update:'Update',
    update_success: 'Update successful',
}
